(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator-result.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/step-indicator/assets/javascripts/step-indicator-result.js');
"use strict";


const Shield = svs.components.lbUi.shield.Shield;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const useCompetitionId = svs.components.marketplaceCompetition.competitionContext.useCompetitionId;
const _svs$components$marke = svs.components.marketplaceCompetition.services.hooks,
  useCompetitionType = _svs$components$marke.useCompetitionType,
  useCompetitionBranding = _svs$components$marke.useCompetitionBranding;
const StepIndicatorResult = _ref => {
  let drawResults = _ref.drawResults,
    labels = _ref.labels,
    isTeamDetails = _ref.isTeamDetails,
    hasUnits = _ref.hasUnits;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const competitionId = useCompetitionId();
  const compType = useCompetitionType(competitionId);
  const competitionBranding = useCompetitionBranding(compType);
  let sizeClass;
  let hasShadow = true;
  if (isTeamDetails) {
    sizeClass = isSmall ? 'shield-small' : 'shield-almost-medium';
    hasShadow = false;
  } else {
    sizeClass = isSmall ? 'shield-almost-medium' : 'shield-medium';
  }
  const getBrandingClass = result => {
    if (result.hasPlayed && result.isContributing) {
      if (result.hasHighestScore) {
        return "shield-".concat(competitionBranding, "-gold");
      }
    } else {
      return "shield-".concat(competitionBranding, "-disabled");
    }
  };
  const _renderResult = (result, index) => {
    const drawNumber = result.drawNumber,
      hasPlayed = result.hasPlayed,
      correctCount = result.correctCount;
    const label = Array.isArray(labels) ? labels[index].label : null;
    const brandingClass = getBrandingClass(result);
    return React.createElement("div", {
      "aria-hidden": "true",
      className: "competition-step-indicator-item",
      key: drawNumber
    }, React.createElement(Shield, {
      branding: competitionBranding,
      className: [sizeClass, brandingClass].filter(Boolean).join(' '),
      options: {
        hasShadow,
        hasHover: true
      }
    }, React.createElement("span", {
      className: "shield-value"
    }, hasPlayed ? correctCount : '-'), Boolean(hasPlayed && hasUnits) && React.createElement("span", {
      className: "shield-unit"
    }, "r\xE4tt")), Boolean(label) && React.createElement("div", {
      className: "step-indicator-label"
    }, label));
  };
  const getLiveMessage = drawResults => drawResults.map((result, index) => {
    const hasPlayed = result.hasPlayed,
      correctCount = result.correctCount;
    const label = Array.isArray(labels) ? labels[index].ariaLabel : null;
    let msg = hasPlayed ? "".concat(label, ": ").concat(correctCount, " r\xE4tt") : "".concat(label, ": ej spelad");
    if (result.hasPlayed && !result.isContributing) {
      msg += ', omgång räknas ej på grund av lägsta resultat i tävlingen.';
    }
    return msg;
  });
  return React.createElement("div", {
    className: isTeamDetails ? 'competition-step-indicator-result-team' : 'competition-step-indicator-result-player'
  }, React.createElement("span", {
    className: "sr-only"
  }, getLiveMessage(drawResults).join(' ')), drawResults.map(_renderResult));
};
setGlobal('svs.components.marketplaceShared.stepIndicator.StepIndicatorResult', StepIndicatorResult);

 })(window);